/* eslint-disable */
import { ComponentDefinition } from '../index';

declare var Object: any;
export interface SlotDefinitionInterface {
  id?: string;
  key: string;
  title?: string;
  description?: string;
  index?: number;
  componentDefinitionId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  componentDefinition?: ComponentDefinition;
}

export class SlotDefinition implements SlotDefinitionInterface {
  'id'?: string;
  'key': string;
  'title': string;
  'description': string;
  'index': number;
  'componentDefinitionId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  componentDefinition: ComponentDefinition;
  constructor(data?: SlotDefinitionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SlotDefinition`.
   */
  public static getModelName() {
    return 'SlotDefinition';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of SlotDefinition for dynamic purposes.
   **/
  public static factory(data: SlotDefinitionInterface): SlotDefinition {
    return new SlotDefinition(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'SlotDefinition',
      plural: 'SlotDefinitions',
      path: 'slot-definitions',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        key: {
          name: 'key',
          type: 'string',
        },
        title: {
          name: 'title',
          type: 'string',
        },
        description: {
          name: 'description',
          type: 'string',
        },
        index: {
          name: 'index',
          type: 'number',
        },
        componentDefinitionId: {
          name: 'componentDefinitionId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        componentDefinition: {
          name: 'componentDefinition',
          type: 'ComponentDefinition',
          model: 'ComponentDefinition',
          relationType: 'belongsTo',
          keyFrom: 'componentDefinitionId',
          keyTo: 'id',
        },
      },
    };
  }
}
